import { withSearch } from '@elastic/react-search-ui';
import DropDownFacetFilters from '../../../components/filter/DropDownFacetFilter';

function HARTrendFilter({ setFilter, removeFilter, facets, filters }) {
  return (
    <DropDownFacetFilters
      facets={facets}
      fieldId="trend"
      filters={filters}
      id="trend"
      label="Trend"
      removeFilter={removeFilter}
      setFilter={setFilter}
      sort={true}
    />
  );
}

export default withSearch(({ setFilter, removeFilter, facets, filters }) => ({
  setFilter,
  removeFilter,
  facets,
  filters,
}))(HARTrendFilter);
